/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
if ($('.filter').length > 0) {
  $('.filter h5').click(function () {
    if ($(this).siblings('ul').length) {
      $(this).siblings('ul').slideToggle();
      $(this).toggleClass('openUl');
    }
  });

  // reload on partial postback
  const prm = Sys.WebForms.PageRequestManager.getInstance();

  if (prm !== null) {
    prm.add_endRequest((sender) => {
      if (sender._postBackSettings.panelsToUpdate !== null) {
        $('.filter h5').click(function () {
          if ($(this).siblings('ul').length) {
            $(this).siblings('ul').slideToggle();
            $(this).toggleClass('openUl');
          }
        });
      }
    });
  }
}
